<app-list-table-filters-wrapper
  [title]="'Crop identification' | translate"
  [parentRoute]="'/crop-identification'"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [(filterModel)]="filterModel"
  [filtersForms]="filtersForms"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
  [isLoading]="loading"
  [storageKey]="null"
  [toggleFilter]="toggleFilter"
  [filtersParams]="filtersParams"
  [columns]="tableColumns()"
  (currentPageData)="loadLinkedModelsData($event)"
>

  <ng-container controller>

    <button
      pButton
      type="button"
      [label]="'Export' | translate"
      icon="pi pi-download"
      class="p-button"
      (click)="onExport()"
      [disabled]="isExporting()">
      <ng-container *ngIf="isExporting()">
        <i class="pi pi-spin pi-spinner" style="margin-left: 8px;"></i>
      </ng-container>
    </button>
  </ng-container>

  <ng-template #regionTemplate let-row>
    <app-region-display [regionId]="getRegionIdForRow(row)"/>
  </ng-template>

  <ng-template #plannedCropTemplate let-row>
    @if (row.plannedCropNames) {
      {{ row.plannedCropNames | localizeValuePipe }}
    } @else {
      -
    }
  </ng-template>

  <ng-template #areaTemplate let-row>
    <div class="flex flex-row-reverse w-full">
      <div class="flex-row-reverse">
        {{ (row.fieldArea | msfNumber) || '-' }}
      </div>
    </div>
  </ng-template>

  <ng-template #dateTemplate let-row>
    {{ row?.identificationDate | dateFormatLang: translateService.currentLang : true }}
  </ng-template>

  <ng-template #actionsTemplate let-row>
    <div class="crop-identification-list__actions">
      <button
        pButton
        type="button"
        icon="pi pi-camera"
        class="p-button-text p-button-sm"
        [pTooltip]="'Create request' | translate"
        [disabled]="!getFieldId(row)"
        (click)="openCreateRequest(row, $event)">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-map-marker"
        class="p-button-text p-button-sm"
        [pTooltip]="'GO_TO_POINT' | translate"
        (click)="openOnGis(row, $event)">
      </button>
    </div>
  </ng-template>

  <ng-template #fieldTemplate let-row let-col="col">
    <app-field-passport-link
      [fieldId]="getFieldId(row) || null"
      [fieldName]="getFieldName(row) || null"
    />
  </ng-template>

  <ng-template #sourceTemplate let-row>
    {{ getSourceLabel(row) }}
  </ng-template>

  <ng-template #culture1Template let-row>
    @if (row.topCandidates && row.topCandidates[0]) {
      {{ row.topCandidates[0].names | localizeValuePipe  }}
    } @else {
      -
    }
  </ng-template>
  <ng-template #accuracy1Template let-row>
    @if (row.topCandidates && row.topCandidates[0]) {
      {{ (row.topCandidates[0].score * 100).toFixed(2) }}%
    } @else {
      -
    }
  </ng-template>
  <ng-template #culture2Template let-row>
    @if (row.topCandidates && row.topCandidates[1]) {
      {{ row.topCandidates[1].names | localizeValuePipe  }}
    } @else {
      -
    }
  </ng-template>
  <ng-template #accuracy2Template let-row>
    @if (row.topCandidates && row.topCandidates[1]) {
      {{ (row.topCandidates[1].score * 100).toFixed(2) }}%
    } @else {
      -
    }
  </ng-template>
</app-list-table-filters-wrapper>
